module.exports = __webpack_public_path__ + "static/media/stexLight.01aae6b8.png";